import { NextPage } from "next"
import { useState, useRef, useCallback, useEffect, ChangeEvent } from "react"
import { makeId, getExtension, getFileSizeFromString } from '../util'
import type { IFile, IAllowFileExtensions, IMaxSize } from '../interfaces'
import Button from "@/components/button/Button"
import FileIcon from '../components/FileIcon';

interface IProps {
  items: IFile[];
  className?: string;
  existingItems?: Record<string, any>[];
  deleteHandler?: (id: string) => void;
  existingFileDeleteHandler?: (id: string) => void;
  downloadHandler?: (id: string) => void;
}

const Component: NextPage<IProps> = ({ className, items, existingItems, deleteHandler, existingFileDeleteHandler, downloadHandler }) => {
  const handleExistingFileDelete = useCallback((id: string): void => {
    existingFileDeleteHandler && existingFileDeleteHandler(id);
  }, [existingFileDeleteHandler]);

  const handleDelete = useCallback((id: string): void => {
    deleteHandler && deleteHandler(id);
  }, [deleteHandler]);
  return (
    <div className={`flex flex-col space-y-2 ${className}`}>
      {existingItems && existingItems.map((item: any, index: number) => (
        <div key={index} className="flex items-center justify-start">
          <FileIcon filename={item.name} />
          <div className="pl-2 mr-3 font-normal text-md">{item.name}</div>
          {existingFileDeleteHandler && (
            <Button rounded theme="danger" size="s" className="mr-3" onClick={() => handleExistingFileDelete(item.id)}>삭제</Button>
          )}
          {downloadHandler && (
            <Button rounded theme="info" size="s" className="mr-3" onClick={() => downloadHandler(item.id)}>다운로드</Button>
          )}
        </div>
      ))}
      {items && items.map((item: IFile, index: number) => (
        <div key={index} className="flex items-center justify-start">
          <FileIcon filename={item.object.name} />
          <div className="pl-2 mr-3 font-normal text-md">{item.object.name}</div>
          {deleteHandler && (
            <Button rounded theme="danger" size="s" className="mr-3" onClick={() => handleDelete(item.id)}>삭제</Button>
          )}
        </div>
      ))}
    </div>
  )
}

export default Component;
